var alignment_rtlignore_default = {
  "alignLeft": "QxCat",
  "textWrapNowrap": "D8InU",
  "alignRight": "V9g-b",
  "alignCenter": "rOGFF",
  "sizeFullWidth": "u-fxW",
  "renderedInTable": "dghr4",
  "sizeOriginal": "Bm2XA",
  "sizeContent": "MRNf-",
  "sizeSmall": "OOnZz",
  "sizeSmallCenter": "izl3C",
  "flex": "OeIev",
  "LEFT": "D4L3T",
  "CENTER": "RBYiE",
  "RIGHT": "_767Qj",
  "AUTO": "WzoeH",
  "JUSTIFY": "dknLS"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
